export enum DepositDeductionTypeEnum {
  DEDUCTION = 'deduction',
  REFUND = 'refund',
}
